import { createRoot } from "react-dom/client"

let root = null

export function getRoot(containerId) {
  if (!root) {
    const container = document.getElementById(containerId)
    if (!container) {
      throw new Error(`Container with ID ${containerId} not found`)
    }
    root = createRoot(container)
  }
  return root
}
